module.exports = __webpack_public_path__ + "static/media/logoTeon.e2e0ee4e.svg";